import { mode } from "@chakra-ui/theme-tools";

export const inputStyles = {
  components: {
    Input: {
      variants: {
        primary: (props) => ({
          field: {
            bg: mode("sky.light", "navy.light")(props),
            color: mode("black", "white")(props),
            height: "55px",
            textAlign: "center",
            borderRadius: "md",
            _placeholder: {
              color: mode("#979797", "#4f5e6c")(props),
            },
            _disabled: {
              opacity: 0.5,
            },
          },
        }),
        // login: (props) => ({
        //   field: {
        //     bg: "rgba(0,0,0,0.4)",
        //     color: "white",
        //     height: "70px",
        //     textAlign: "center",
        //     borderRadius: "2xl",
        //     _placeholder: {
        //       color: "#d6d6d6",
        //     },
        //     _disabled: {
        //       opacity: 0.5,
        //     },
        //   },
        // }),
        tableColumnFilter: (props) => ({
          field: {
            bg: mode("white", "navy.dark")(props),
            height: "45px",
            width: "90%",
            mt: "20px",
            textAlign: "center",
            borderRadius: "2xl",
            fontSize: "12px",
            _placeholder: {
              color: mode("primary.700", "darkGray.light")(props),
            },
            _disabled: {
              opacity: 0.5,
            },
          },
        }),
      },
    },
  },
};
